"use client"

import { getNonUmbracoUrl } from "@/utils"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import React from "react"
import { sendBlockEvent } from "utils/gtm"
import { transformProperties } from "utils/simplifyData"
import { ButtonWithArrowTall } from "../common/bit/ButtonWithArrow"
import CommonTitle from "../common/bit/CommonTitle"
import InfoLink from "../common/bit/InfoLink"
import { colors, mediaQueries, sizes } from "../theme/theme"

interface ButtonsListProps {
  data: {
    isSmallerTitle?: boolean
    title: string
    itemsList: {
      blocks: Array<{
        properties: Record<string, any>
      }>
    }
    link?: {
      links: any
      url: string
      name: string
    }
  }
  style?: React.CSSProperties
}

const ButtonsListWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: inherit;
  ${mediaQueries.tablet} {
    align-items: flex-start;
  }
`
const StyledButtonWithArrow = styled(ButtonWithArrowTall)`
  justify-content: space-between;
  padding: ${sizes.baseDouble} ${sizes.baseTriple};
  margin-bottom: ${sizes.baseDouble};
  box-shadow: none;
  width: 100%;
  .title {
    text-align: start;
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    color: ${colors.red};
  }
  .text {
    padding: 0;
    text-align: start;
  }
`

const StyledCommonTitle = styled(CommonTitle, {
  shouldForwardProp: (prop) => prop !== "isSmallerTitle",
})<{ isSmallerTitle?: boolean }>`
  ${mediaQueries.tabletDown} {
    margin-top: ${sizes.baseSingle};
    text-align: center;
  }
  ${mediaQueries.desktopM} {
    align-self: flex-start;
  }
  .title {
    font-size: ${({ isSmallerTitle }) => (isSmallerTitle ? "33px" : "inherit")};
    ${mediaQueries.desktopM} {
      font-size: ${({ isSmallerTitle }) =>
        isSmallerTitle ? "38px" : "inherit"};
    }
    ${mediaQueries.desktopXl} {
      font-size: ${({ isSmallerTitle }) =>
        isSmallerTitle ? "44px" : "inherit"};
    }
  }
`

const StyledButtonContainer = styled(Box)``

interface LinkIconCardListProps extends ButtonsListProps {
  data: any
  id?: string
  componentEventName?: string
}

const LinkIconCardList: React.FC<LinkIconCardListProps> = ({
  data,
  id,
  componentEventName,
}) => {
  const { title, itemsList, link, isSmallerTitle } = data
  const { blocks } = itemsList

  // Local GTM event handler
  const handleButtonClick = (buttonName: string) => {
    sendBlockEvent({
      blockId: id || "3",
      title: title,
      componentName: componentEventName || "מידע נוסף",
      buttonName,
      actionName: undefined,
      // component_no: "5"
    })
  }

  return (
    <ButtonsListWrapper>
      <StyledCommonTitle isSmallerTitle={isSmallerTitle}>
        {title}
      </StyledCommonTitle>
      {blocks && (
        <StyledButtonContainer>
          {blocks.map((item: any, index: number) => {
            const { title, text, link } = transformProperties(item?.properties)
            return (
              <StyledButtonWithArrow
                key={`accordion-item-${title?.value}-${index}`}
                arrowName="arrow_lightRed_black"
                variant="elevated"
                colorPallette="red"
                href={getNonUmbracoUrl(link?.links[0]?.url)}
                onClick={() => handleButtonClick(title?.value)}
              >
                {title && (
                  <Typography variant="body1" component="h3" className="title">
                    {title?.value}
                  </Typography>
                )}
                {text && (
                  <Typography variant="body2" className="text">
                    {text?.value}
                  </Typography>
                )}
              </StyledButtonWithArrow>
            )
          })}
        </StyledButtonContainer>
      )}
      {link && (
        <InfoLink href={getNonUmbracoUrl(link?.links[0]?.url)}>
          {link?.links[0]?.name}
        </InfoLink>
      )}
    </ButtonsListWrapper>
  )
}

export default LinkIconCardList
